// Куда встать адресной строке ПОСЛЕ разбора ссылки из письма.
//
// Ссылка входа ведёт на /app/auth/verify?token=… — это ТЕХНИЧЕСКИЙ адрес, у
// которого нет и не должно быть своего раздела. Прежний код чистил только
// параметр и оставлял путь как есть: маршрут не совпадал ни с одним, <Routes>
// рисовал НИЧЕГО, и вошедший человек получал ровно фон страницы — «чёрный
// экран» (бой 29.08.2026, снимок: 1440×900 одного цвета rgb(11,27,51)).
//
// Отказ немой до последней степени: вход прошёл, токен выдан, сессия жива, в
// консоли одно предупреждение роутера. Отличить это от упавшего кабинета
// человеку нечем.
//
// Токен из адреса убирается ВСЕГДА, на любом пути: он одноразовый, и оставлять
// его в истории браузера и в закладке нельзя.
export const HOME = '/app/'
export const VERIFY_PATH = '/app/auth/verify'

export function afterVerifyUrl(pathname: string, search: string): string {
  const params = new URLSearchParams(search)
  params.delete('token')
  const rest = params.toString()
  // Хвостовой слэш не различает адрес: /app/auth/verify/ — тот же путь.
  if (pathname.replace(/\/$/, '') === VERIFY_PATH) return HOME
  return pathname + (rest ? `?${rest}` : '')
}
